/**
 * MembershipBadge Component
 * Displays member's current plan level
 */

import React from 'react';
import './MembershipBadge.css';

export type MembershipPlan = 'free' | 'basic' | 'premium';

interface MembershipBadgeProps {
  plan: MembershipPlan;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const PLAN_CONFIG: Record<
  MembershipPlan,
  { label: string; color: string; icon: string }
> = {
  free: {
    label: '免費會員',
    color: 'gray',
    icon: '👤',
  },
  basic: {
    label: '基本會員',
    color: 'blue',
    icon: '⭐',
  },
  premium: {
    label: '高級會員',
    color: 'gold',
    icon: '👑',
  },
};

export const MembershipBadge: React.FC<MembershipBadgeProps> = ({
  plan,
  showLabel = true,
  size = 'md',
}) => {
  const config = PLAN_CONFIG[plan];

  return (
    <div className={`membership-badge membership-badge--${config.color} membership-badge--${size}`}>
      <span className="membership-badge__icon">{config.icon}</span>
      {showLabel && (
        <span className="membership-badge__label">{config.label}</span>
      )}
    </div>
  );
};

interface MembershipLimitsProps {
  plan: MembershipPlan;
  currentAds: number;
  currentContacts: number;
}

export const MembershipLimits: React.FC<MembershipLimitsProps> = ({
  plan,
  currentAds,
  currentContacts,
}) => {
  const limits = {
    free: { maxAds: 0, maxContacts: 0 },
    basic: { maxAds: 10, maxContacts: 50 },
    premium: { maxAds: null, maxContacts: null },
  };

  const planLimits = limits[plan];

  return (
    <div className="membership-limits">
      <div className="membership-limits__item">
        <span className="membership-limits__label">廣告數量</span>
        <span className="membership-limits__value">
          {plan === 'free' ? '無法刊登' : `${currentAds} / ${planLimits.maxAds === null ? '無限' : planLimits.maxAds}`}
        </span>
      </div>
      <div className="membership-limits__item">
        <span className="membership-limits__label">聯繫次數</span>
        <span className="membership-limits__value">
          {plan === 'free' ? '無法聯繫' : `${currentContacts} / ${planLimits.maxContacts === null ? '無限' : planLimits.maxContacts}`}
        </span>
      </div>
    </div>
  );
};
